/**
 * cancelledPartialMessage — la burbuja del parcial que deja un ⏹ (#494, #1558).
 *
 * Vive aquí, y no inline en cada consumidor, por lo mismo que `liveBubblePolicy.js`:
 * las DOS máquinas de sesión del chat (`Chat.jsx` y `useModularChat.ts`) construyen
 * esta burbuja a partir del mismo evento, y las dos copias se escribieron sin nombre
 * ni color. La burbuja salía firmada «Agent» (`MessageBubble`: `agentName || 'Agent'`)
 * y con el color derivado del nombre, mientras la fila de la BD tenía los buenos:
 * al recargar la página cambiaba de nombre y de color.
 *
 * El nombre y el color los decide el backend al persistir el parcial y viajan en el
 * propio `stream-cancelled` (`turnCancellationService`), así que aquí solo se copian.
 */

/**
 * Mensaje a inyectar en la lista para un `stream-cancelled`, o null si no hay nada que
 * pintar: sin `messageId` el backend no persistió parcial (STOP antes del primer token,
 * o persist fallido) y el corte solo se confirma.
 *
 * @param {{ threadId?: string, finalized?: boolean, messageId?: string|null,
 *           partialText?: string|null, agentName?: string|null, color?: string|null }
 *         | null | undefined} payload
 * @returns {{ id: string, thread_id: string|undefined, content: string, sender: 'assistant',
 *             timestamp: Date, message_type: 'text', agentName: string|null,
 *             color: string|null, cancelledByUser: true } | null}
 *   shape espejo del `agent_message` (campo `content`, dedup por `id`)
 */
export function cancelledPartialMessage(payload) {
  if (!payload?.finalized || !payload.messageId) return null;
  return {
    id: payload.messageId,
    thread_id: payload.threadId,
    content: payload.partialText ?? '',
    sender: 'assistant',
    timestamp: new Date(),
    message_type: 'text',
    agentName: payload.agentName ?? null,
    color: payload.color ?? null,
    cancelledByUser: true,
  };
}
